<template>
  <div class="pd-horizontal-4">
    <div class="tit-h5">{{ t('ss_card_payment_history') }}</div>
    <Tabs :tabs="listTab" :active-tab="tabActive" size="big" @tabClick="handleTabClick" />

    <template v-if="listInvoiceParsed.length > 0">
      <div ref="refDayDetail" class="day-detail-con pdb-8">
        <InvoiceHistory
          v-for="invoiceDetail in listInvoiceParsed"
          :key="invoiceDetail.paymentId"
          :invoice-detail
          :isCancelled="true"
        />
      </div>
      <ButtonGetMore v-if="hasMore" @get-more="getListInvoice(true)" />
    </template>

    <div v-else class="no-data pd-vertical-7 no-data-flex">
      <div class="icon-area">
        <img :src="getAssetImageUrl('app/status/no-data.svg')" alt="" />
      </div>
      <span>{{ t('no_records') }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getPaymentHistory } from '@/api/apiService';
import InvoiceHistory from '@/components/domains/self-service/payment-settings/InvoiceHistory.vue';
import ButtonGetMore from '@/components/shared/base/ButtonGetMore.vue';
import Tabs from '@/components/shared/composite/Tabs.vue';
import { IResponsePaymentHistory } from '@/types/response';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const { t } = useI18n();

const refDayDetail = useTemplateRef<HTMLDivElement>('refDayDetail');
const listInvoice = ref<IResponsePaymentHistory[]>([]); // 결제내역 목록
const hasMore = ref(false); // 결제내역 더보기 버튼 노출 여부
const nextOffset = ref(''); // 결제 내역 더보기 조회 기준점
const tabActive = ref(0); // 현재 바라보고 있는 탭

const listTab = computed(() => {
  return ['label_all', 'ss_history_type_payment', 'label_cancel'];
});

const getTypeString = (): string | null => {
  switch (tabActive.value) {
    case 1:
      return 'SUCCESS';
    case 2:
      return 'CANCELED';
    default:
      return '';
  }
};

const getListInvoice = async (isGetMore = false) => {
  const { data } = await getPaymentHistory(getTypeString(), nextOffset.value);
  if (isGetMore) {
    listInvoice.value.push(...data.datas);
    await scrollToBottom();
  } else {
    listInvoice.value = data.datas;
  }

  hasMore.value = data.hasMore;
  nextOffset.value = data.nextOffset ?? '';
};

const listInvoiceParsed = computed(() => {
  const purchased = listInvoice.value.map((item) => ({
    ...item,
  }));

  return purchased.sort((a, b) => {
    const timeA = new Date(a.createdAt).getTime();
    const timeB = new Date(b.createdAt).getTime();

    if (timeA !== timeB) return timeB - timeA; // 최신 먼저

    return timeB - timeA || b.canceledAmount - a.canceledAmount;
  });
});

const handleTabClick = (index) => {
  if (tabActive.value === index) return;
  nextOffset.value = '';
  tabActive.value = index;
  getListInvoice();
};

const scrollToBottom = async () => {
  await nextTick();
  if (!refDayDetail.value) return;

  refDayDetail.value.scrollTo({
    top: refDayDetail.value.scrollHeight,
    behavior: 'smooth',
  });
};

onMounted(() => {
  getListInvoice();
});
</script>

<style scoped lang="scss">
.nd-tab-con {
  .pd-horizontal-4 {
    height: 100%;
  }
  .tit-h5 {
    padding: 2rem 0 0.75rem;
  }
}
.day-detail-con {
  overflow-y: auto;
  height: calc(100% - 200px);
  @include respond-to(mobile-landscape) {
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
